import React, { useState, useEffect, useCallback } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Textarea } from '../ui/textarea';
import { Save, Loader2 } from 'lucide-react';
import { toast } from 'sonner';
import { contentAPI } from '../../services/api';

const HeroEditor = () => {
  const [data, setData] = useState(null);
  const [saving, setSaving] = useState(false);

  const load = useCallback(async () => {
    try { const res = await contentAPI.get('hero'); setData(res.data || {}); }
    catch { toast.error('Failed to load'); }
  }, []);

  useEffect(() => { load(); }, [load]);
  const save = async () => {
    setSaving(true);
    try { await contentAPI.update('hero', data); toast.success('Hero section saved!'); }
    catch { toast.error('Failed to save'); }
    finally { setSaving(false); }
  };

  if (!data) return <div className="flex justify-center py-8"><Loader2 className="w-6 h-6 animate-spin" /></div>;

  return (
    <div className="space-y-6 max-w-4xl">
      <Card>
        <CardHeader><CardTitle>Homepage Hero Section</CardTitle></CardHeader>
        <CardContent className="space-y-4">
          <div>
            <label className="text-sm font-medium text-gray-700 mb-1 block">Headline</label>
            <Input value={data.headline || ''} onChange={e => setData({...data, headline: e.target.value})} data-testid="hero-headline" />
          </div>
          <div>
            <label className="text-sm font-medium text-gray-700 mb-1 block">Subheadline</label>
            <Textarea rows={3} value={data.subheadline || ''} onChange={e => setData({...data, subheadline: e.target.value})} />
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="text-sm font-medium text-gray-700 mb-1 block">Primary CTA Text</label>
              <Input value={data.ctaPrimary || ''} onChange={e => setData({...data, ctaPrimary: e.target.value})} />
            </div>
            <div>
              <label className="text-sm font-medium text-gray-700 mb-1 block">Secondary CTA Text</label>
              <Input value={data.ctaSecondary || ''} onChange={e => setData({...data, ctaSecondary: e.target.value})} />
            </div>
          </div>
          <div>
            <label className="text-sm font-medium text-gray-700 mb-1 block">Hero Background Image URL</label>
            <Input value={data.heroImage || ''} onChange={e => setData({...data, heroImage: e.target.value})} />
            {data.heroImage && <img src={data.heroImage} alt="Preview" className="mt-2 h-40 w-full object-cover rounded-lg" />}
          </div>
        </CardContent>
      </Card>
      <Button onClick={save} disabled={saving} className="w-full" data-testid="save-hero">
        {saving ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : <Save className="w-4 h-4 mr-2" />} Save Hero Section
      </Button>
    </div>
  );
};

export default HeroEditor;
